import { render, staticRenderFns } from "./Tool.vue?vue&type=template&id=9205d0a2&"
import script from "./Tool.vue?vue&type=script&lang=ts&"
export * from "./Tool.vue?vue&type=script&lang=ts&"
import style0 from "./Tool.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports